import {ListableItem} from 'search/SearchConstants';

export interface PartsOrPartLinks {
  partSequenceIds: Array<string>;
  containerSequenceId: string;
  validationError: string | null;
}

export type BulkUnlinkSpec = string;

export enum CategoricalUnlinkSpec {
  ALL = 'ALL',
  ORPHANED = 'ORPHANED',
}

export const CATEGORICAL_UNLINK_SPEC_NAME: {[key in CategoricalUnlinkSpec]: string} = {
  ALL: 'All part link fields',
  ORPHANED: 'All parts not referenced in part links',
};

export function isCategoricalUnlinkSpec(data: BulkUnlinkSpec): data is CategoricalUnlinkSpec {
  return Object.keys(CategoricalUnlinkSpec).includes(data);
}

export interface SequencesById {
  [id: string]: ListableItem;
}

type ValidationError = string | null;

export interface TagSpecForSequence {
  referringSequenceId: string;
  schemaTagId: string;
  partSequenceIds: Array<string>;
  validationError: ValidationError;
}

interface SchemaFieldInfo {
  schemaFieldName: string;
  tagSpecs: Array<TagSpecForSequence>;
}

export interface SchemaFieldInfoById {
  [schemaFieldId: string]: SchemaFieldInfo;
}
